import baseApi from './RootBaseApi';
import {
  HarborOperatorDashboardData,
  HarborOperatorDashboardResponse,
} from '@/types/harbor-operator-dashboard.types';
import {
  normalizeTrendPoints,
  pickRevenueTrendSeries,
} from '@/utils/harborOperatorDashboardTrend';

export const HarborOperatorDashboardService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getHarborOperatorDashboard: builder.query<
      HarborOperatorDashboardData,
      { trendMonths?: number } | void
    >({
      query: (params) => ({
        url: 'admin/dashboard/harbor-operator',
        method: 'GET',
        params: params?.trendMonths
          ? { trendMonths: params.trendMonths }
          : undefined,
      }),
      transformResponse: (response: HarborOperatorDashboardResponse) => {
        const payload = response.data;
        return {
          ...payload,
          bookings_trend: normalizeTrendPoints(payload.bookings_trend),
          revenue_trend: pickRevenueTrendSeries(
            payload.revenue_trend,
            payload.bookings_trend
          ),
        };
      },
      providesTags: ['HarborOperatorDashboard'],
      keepUnusedDataFor: 0,
    }),
  }),
});

export const { useGetHarborOperatorDashboardQuery } =
  HarborOperatorDashboardService;
